import { Stack, styled, Typography } from '@mui/material';

export const StyledWrapper = styled(Stack)({
  width: '100%',
  minHeight: '100%',
  justifyContent: 'start',
  alignItems: 'center',
  backgroundColor: '#ebeef5',
});

export const StyledInner = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(144),
  padding: theme.spacing(3),
  gap: theme.spacing(5),
  justifyContent: 'flex-start',
  alignItems: 'center',
  boxSizing: 'border-box',
  borderRadius: theme.spacing(1),
}));

export const StyledHeader = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  fontSize: '30px',
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '36px',
});

export const StyledSubHeader = styled(Typography)({
  fontFamily: '"Inter", sans-serif',
  color: '#4b5563',
  fontSize: '18px',
  lineHeight: '28px',
});

export const StyledHeaderContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(144),
  padding: theme.spacing(0, 3),
  marginTop: 20,
  gap: theme.spacing(1),
}));
